import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { DOMAIN, USERS_API_URL } from '../../config';
import { readFromStorage } from '../webStorage';
import userAxios from './user.axios';
import Cookies from 'js-cookie';

const axiosConfig: AxiosRequestConfig = {
    baseURL: `${USERS_API_URL}` || 'http://localhost:3000/',
      headers: {
    'ngrok-skip-browser-warning': 'true',
  },
};
const brokersRolesAxios = axios.create(axiosConfig);

const logout = () => {
    Cookies.remove('accessToken', {
        domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
        path: '/',
    });
    Cookies.remove('refreshToken', {
        domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
        path: '/',
    });
    Cookies.remove('user', {
        domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
        path: '/',
    });
    Cookies.remove('roles', {
        domain: String(DOMAIN).replace(/^https?:\/\//, '.'),
        path: '/',
    });
    window.location.href = DOMAIN || '/';
};

// reqeust intercpetor
brokersRolesAxios.interceptors.request.use((config) => {
    const token = Cookies.get('accessToken') || readFromStorage('accessToken');
    // const isValid = validateJWT(token);
    if (token) {
        return {
            ...config,
            headers: {
                'Access-Control-Allow-Origin': '*',
                Authorization: `Bearer ${token}`,
                'ngrok-skip-browser-warning': 'true'
            },
        };
    }
    return config;
});

// Add a response interceptor
brokersRolesAxios.interceptors.response.use(
    (response) => {
        if (response?.data?.error === 'No permission!') logout();
        return response;
    },
    async (error) => {
        const err = { ...error };
        if (error.response.status === 401) {
            const err = { ...error };
            const originalRequest = err.config;
            if (!originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    const token =
                        Cookies.get('refreshToken') ||
                        readFromStorage('refreshToken');
                    const response = await userAxios.post(
                        '/dom/refresh-token',
                        { token },
                    );
                    const accessToken = response.data.data.token;
                    Cookies.set('accessToken', accessToken, {
                        domain: String(process.env.REACT_APP_DOMAIN).replace(
                            /^https?:\/\//,
                            '.',
                        ),
                        path: '/',
                        secure: true,
                        sameSite: 'None',
                    });
                    axios.defaults.headers.common.Authorization =
                        'Bearer ' + accessToken;
                    return brokersRolesAxios(originalRequest);
                } catch (e) {
                    console.error(e);
                    logout();
                }
            } else {
                logout();
            }
        }
        return Promise.reject(err);
    },
);

export const brokersAxiosQuery =
    (): BaseQueryFn<{
        url: string;
        method: AxiosRequestConfig['method'];
        data?: AxiosRequestConfig['data'];
    }> =>
    async ({ url, method, data }) => {
        const baseUrl = axiosConfig.baseURL;
        try {
            const result = await brokersRolesAxios({
                url: baseUrl + url,
                method,
                data,
            });
            return { data: result.data };
        } catch (axiosError) {
            const err = axiosError as AxiosError;
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data,
                },
            };
        }
    };

export default brokersRolesAxios;
